import { render, staticRenderFns } from "./CustomTable.vue?vue&type=template&id=d8d5d2b4&scoped=true"
import script from "./CustomTable.vue?vue&type=script&lang=js"
export * from "./CustomTable.vue?vue&type=script&lang=js"
import style0 from "./CustomTable.vue?vue&type=style&index=0&id=d8d5d2b4&prod&lang=scss"
import style1 from "./CustomTable.vue?vue&type=style&index=1&id=d8d5d2b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1f634a4a4b1fea536ed4e950e01c2669/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d5d2b4",
  null
  
)

export default component.exports